{
  "title": "O‘yin lobbisi",
  "subtitle": "Aggregator katalogidagi barcha o‘yinlar shu yerda mavjud.",
  "searchPlaceholder": "O‘yin qidirish",
  "categories": "Toifalar",
  "all": "Hammasi",
  "slots": "Slotlar",
  "live": "Jonli kazino",
  "crash": "Crash",
  "instant": "Instant",
  "table": "Stol",
  "other": "Boshqa",
  "popular": "Mashhur",
  "new": "Yangi",
  "jackpot": "Jackpot",
  "tags": "Filtrlar",
  "providers": "Provayderlar",
  "emptyTitle": "O‘yinlar hali mavjud emas",
  "emptyBody": "Provayder katalogi sinxronlanmagan. Haqiqiy yoki demo o‘yinlar faqat tasdiqlangan integratsiyadan keyin yoqiladi.",
  "errorTitle": "Katalog yuklanmadi",
  "errorBody": "O‘yinlar ro‘yxatini olishda xato yuz berdi. Keyinroq qayta urinib ko‘ring.",
  "notPlayable": "Hozir ochib bo‘lmaydi",
  "demoUnavailable": "Demo hali faol emas",
  "realMoneyDisabled": "Haqiqiy pul o‘yinlari o‘chirilgan",
  "provider": "Provayder",
  "results": "{{count}} o‘yin",
  "featured": "Tanlangan",
  "lobbySection": "Katalog",
  "allProviders": "Barcha provayderlar",
  "sort": "Saralash",
  "sortRecommended": "Tavsiya etilgan",
  "sortName": "Nom",
  "sortProvider": "Provayder",
  "favorite": "Sevimli",
  "selectWallet": "O‘yin oldidan balansni tanlang",
  "realBalance": "Asosiy balans",
  "bonusBalance": "Bonus balans",
  "fundingLocked": "Tanlangan balans butun o‘yin sessiyasi davomida saqlanadi. Haqiqiy va bonus mablag‘lari aralashtirilmaydi.",
  "launchPlay": "O‘ynash",
  "bonusNotSlot": "Bonus faqat tasdiqlangan slotlarda ishlatiladi",
  "bonusPlayDisabled": "Bonus o‘yin hali faol emas",
  "sessionFundingUnsupported": "Provayder sessiya moliyalashtirish manbasini xavfsiz saqlay olmadi. Bu rejim bloklandi.",
  "loginToPlay": "O‘ynash uchun kiring",
  "sessionLaunched": "O‘yin sessiyasi yaratildi",
  "loadMore": "Ko‘proq ko‘rsatish",
  "loadingMore": "Yuklanmoqda…",
  "showingOf": "{{shown}} / {{total}} o‘yin",
  "launchDemo": "DEMO O‘YNASH",
  "launchReal": "REAL BALANS BILAN O‘YNASH",
  "launchBonus": "BONUS BALANS BILAN O‘YNASH",
  "demoLaunched": "Demo sessiya yaratildi",
  "history": "O‘yin tarixi",
  "searchResults": "Qidiruv",
  "bonusContinueTitle": "Bonus bilan davom?",
  "bonusContinueBody": "Asosiy balans 0. Bonus bor — faqat tanlasangiz.",
  "openExternal": "O‘yinni ochish",
  "openExternalHint": "O‘yin ichida ochilmasa, pastdagi tugmani bosing.",
  "backToCatalog": "Katalogga qaytish",
  "notFound": "O‘yin topilmadi",
  "recommended": "Tavsiya etilganlar",
  "fastGames": "Tez o‘yinlar",
  "bonusWager": "Bonus bilan tikish"
}
